import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { PackingBoxCreateLabelComponent } from 'src/app/views/packing-box/dialog/create-label/create-label.component';
import { PackingBoxCreateLabelFormDirective } from 'src/app/views/packing-box/dialog/create-label/create-label.directive';
import { CompoundingSimpleLabelService } from './simple-batch.service';
import { PackingBoxCreateLabelService } from 'src/app/views/packing-box/dialog/create-label/create-label.service';
import { PackingBoxCreateLabelType } from 'src/app/views/packing-box/types/create-label-dialog';
import { ApiRouteWorkOrderBatchTypes } from '../../../../api/elite/dto/work-order-batch.dto';
export type CompoundingPackingBoxCreateLabelType = {
  data: DataInfo;
  response: ResponseInfo;
};
type DataInfo = PackingBoxCreateLabelType['data'] & {
  batches?: ApiRouteWorkOrderBatchTypes['simpleBatches']['result'];
};
type ResponseInfo = PackingBoxCreateLabelType['response'] & {
  workOrderBatchId?: number;
  batch: string;
};
@Component({
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatInputModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatSelectModule,
    MatSlideToggleModule,
    PackingBoxCreateLabelComponent,
    PackingBoxCreateLabelFormDirective,
    NgxMatSelectSearchModule,
  ],
  templateUrl: 'simple-batch.component.html',
  providers: [
    {
      provide: PackingBoxCreateLabelService,
      useClass: CompoundingSimpleLabelService,
    },
  ],
})
export class CompoundingPackingSimpleLabelComponent implements OnInit {
  data: DataInfo = inject(MAT_DIALOG_DATA);
  private readonly service = inject(
    PackingBoxCreateLabelService
  ) as CompoundingSimpleLabelService;

  get form() {
    return this.service.formBatches;
  }
  batches = Array.isArray(this.data.batches)
    ? this.data.batches
    : [this.data.batches];

  get filteredBatches() {
    return this.service.filteredBatches;
  }

  ngOnInit(): void {
    if (Array.isArray(this.data.batches)) {
      this.service.selectingBatches(this.data.batches);
    } else {
      this.service.automaticBatchSelection(this.data.batches);
      this.data.maxQuantity = this.data.batches.maxQuantity;
    }
  }
}
